// imports
import Component from 'minsky-kit/js/components/Component';
import gsap from 'gsap';

// private statics
const selectors = {
    trigger: '.js-form-modal__trigger',
    close: '.js-form-modal__close',
    modal: '.js-form-modal__modal',
    content: '.js-form-modal__content',
    backdrop: '.js-form-modal__backdrop',
};

// class definition
export default class FormModal extends Component {
    // constructor
    constructor(args = {}, objectName = 'FormModal') {
        args.debug = args.debug || true;

        // super
        super(args, objectName);

        this.$trigger = this.$el.querySelector(selectors.trigger);
        this.$close = this.$el.querySelector(selectors.close);
        this.$modal = this.$el.querySelector(selectors.modal);
        this.$content = this.$el.querySelector(selectors.content);
        this.$backdrop = this.$el.querySelector(selectors.backdrop);

        if (this.$trigger && this.$modal && this.$content) {
            this.init();
        }

        window.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27) {
                this.close();
            }
        });
    }

    init() {
        this.$trigger.addEventListener('click', this.open.bind(this));
        this.$close.addEventListener('click', this.close.bind(this));
        this.$backdrop.addEventListener('click', this.close.bind(this));

        this.$modal.addEventListener('close', () => {
            document.body.style.overflow = 'auto';

            gsap.set(this.$modal, {
                clearProps: 'all',
            });
        });

        this.$content.addEventListener('scroll', (e) => {
            // If at bottom, remove the scroll class
            if (e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight) {
                this.$modal.classList.remove('has-scroll');
            } else {
                this.$modal.classList.add('has-scroll');
            }
        });
    }

    open() {
        document.body.style.overflow = 'hidden';

        this.$modal.show();

        const tlModal = gsap.timeline();
        const tlBackdrop = gsap.timeline();

        tlModal.to(this.$modal, {
            duration: 0.3,
            opacity: 1,
            display: 'block',
            ease: 'power2.inOut',
        });

        tlBackdrop.to(this.$backdrop, {
            duration: 0.3,
            opacity: 1,
            display: 'block',
            ease: 'power2.inOut',
        });

        if (this.contentHasOverflow()) {
            this.$modal.classList.add('has-scroll');
        }
    }

    close() {
        const tlModal = gsap.timeline();
        const tlBackdrop = gsap.timeline();

        tlModal.to(this.$modal, {
            duration: 0.3,
            opacity: 0,
            display: 'none',
            ease: 'power2.inOut',
            onComplete: () => {
                document.body.style.overflow = 'auto';
                this.$modal.close();
            },
        });

        tlModal.to(this.$modal, {
            clearProps: 'opacity',
        });

        tlBackdrop.to(this.$backdrop, {
            duration: 0.3,
            opacity: 0,
            display: 'none',
            ease: 'power2.inOut',
        });
    }

    contentHasOverflow() {
        return this.$content.scrollHeight > this.$content.clientHeight || this.$content.scrollWidth > this.$content.clientWidth;
    }

    // methods
    destroy() {
        super.destroy();
    }
    // getters & setters
}

// Utils

// Event handlers
